"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../shared/core");
var section_ids_1 = require("../../../../section-ids");
var Error = function (_a) {
    var _b = _a.isFetching, isFetching = _b === void 0 ? false : _b;
    var ErrorSection = (0, core_1.useComponents)().ErrorSection;
    return isFetching ? null : (react_1.default.createElement("section", null,
        react_1.default.createElement(ErrorSection, { id: section_ids_1.BILLING_ERROR, "data-testid": section_ids_1.BILLING_ERROR })));
};
exports.Error = Error;
